// extracted by mini-css-extract-plugin
export var container = "_5q-0";
export var containerTopRight = "_5q-1";